import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useContext, useEffect, useState } from "react";
import { getAllByOrganizationId, getDeparment, updateDepartment } from "../../service/User";
import AppContext from "../../context/AppContext";
import translations from "../common/Translations";
import CommonButton from "../common/CommonButton";
import ModalCloseButton from "../common/ModalCloseButton";

const CreateDepartment = ({ setOpen, open, organizationID, setgetDeparment, onDepartmentSaved, editDepartmentId, editDepartmentName, setEditDepartmentId, setEditDepartmentName }) => {
    const { theme, langMode } = useContext(AppContext);
    const [deparmentName, setDeparmentName] = useState(editDepartmentName ?? "");

    const isEditMode = Boolean(editDepartmentId);

    const handleAddDeparment = async () => {
        if (isEditMode) {
            await updateDepartment({ id: editDepartmentId, organizationId: organizationID, name: deparmentName });
            if (setEditDepartmentId) setEditDepartmentId(null);
            if (setEditDepartmentName) setEditDepartmentName("");
        } else {
            await getDeparment({ organizationId: organizationID, name: deparmentName });
        }
        const result = await getAllByOrganizationId(organizationID);
        if (onDepartmentSaved) {
            onDepartmentSaved(organizationID, result);
        } else {
            setgetDeparment(result);
        }
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            setDeparmentName(editDepartmentName ?? "");
        }
    }, [open, editDepartmentName]);

    const isDark = theme === "dark";
    const isContrast = theme === "high-contrast";

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity" />
                </Transition.Child>
                <div className="fixed inset-0 z-50 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-2.5 sm:p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-150"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className={`max-h-[calc(100dvh-1rem)] w-full max-w-md transform overflow-y-auto overflow-x-hidden rounded-xl p-3 shadow-xl transition-all sm:rounded-2xl sm:p-6
                ${isDark ? "bg-[#1E1E1E] text-white" : isContrast ? "bg-white text-black border border-black" : "bg-white text-gray-800"}`}
                            >
                                <div className="flex justify-between items-center mb-4">
                                    <Dialog.Title className="text-lg font-semibold"> 
                                        {isEditMode ? translations[langMode].editDepartment ?? "Edit Department" : translations[langMode].addDepartment}
                                    </Dialog.Title>
                                    <ModalCloseButton onClick={() => setOpen(false)} />
                                </div>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium mb-1">
                                            {translations[langMode].departmentname}
                                        </label>
                                        <input
                                            type="text"
                                            value={deparmentName}
                                            onChange={(e) => setDeparmentName(e.target.value)}
                                            placeholder={translations[langMode].entername}
                                            className={`w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm
                      focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50
                      ${isDark ? "bg-[#2C2C2C] text-white border-gray-600" : ""}
                      ${isContrast ? "border-black text-black" : ""}`}
                                        />
                                    </div>
                                </div>
                                <div className="mt-6 flex w-full justify-end items-center gap-2 sm:gap-3">
                                    <CommonButton colorIntent="danger"
                                        onClick={() => setOpen(false)}
                                        variant="danger"
                                        wrapperClassName="flex-1 min-w-0 flex sm:inline-block sm:flex-initial"
                                        className="w-full !h-10 !rounded-lg justify-center"
                                    >
                                        {translations[langMode].cancle}
                                    </CommonButton>
                                    <CommonButton colorIntent="success"
                                        onClick={handleAddDeparment}
                                        variant="primary"
                                        wrapperClassName="flex-1 min-w-0 flex sm:inline-block sm:flex-initial"
                                        className="w-full !h-10 !rounded-lg justify-center"
                                    >
                                        {translations[langMode].save}
                                    </CommonButton>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default CreateDepartment;
